import React, { useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {NewsFullPage} from "../../Components/media-intelligence/NewsFullPage";

// Resolve the active election mode id the same way ElectionModeFullScreen does.
const getElectionModeId = () => {
  const stored = localStorage.getItem("electionModeId");
  if (stored) return stored;
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.electionModeId || null;
  } catch {
    return null;
  }
};

const MediaIntelligence = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const electionModeId = getElectionModeId();

  // Filters are passed via query params so the page lands pre-filtered to
  // whatever the user was viewing in Election Mode.
  const filters = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      region: params.get("region") || "",
      district: params.get("district") || "",
      constituency: params.get("constituency") || "",
      party: params.get("party") || "",
    };
  }, [location.search]);

  const handleBack = () => {
    navigate("/election-mode");
  };

  if (!electionModeId) {
    return (
      <div className="flex items-center justify-center h-[60vh] text-slate-400">
        {t("ElectionMode.failedToLoadNews", "No election mode found")}
      </div>
    );
  }

  return (
    <NewsFullPage
      electionModeId={electionModeId}
      filters={filters}
      t={t}
      onClose={handleBack}
    />
  );
};

export default MediaIntelligence;
